import React from 'react';
import { Text, View } from 'react-native';
import { modalExperience } from '../../shared/modals/modalExperience.styles';
import { formatLocalDate } from '@shared/vueltoDateTime';
import type { CustomerAccountRow } from '../domain/customerTypes';

type Props = {
  customer: CustomerAccountRow;
  formatMoney: (n: number) => string;
};

export function CustomerDetailPortalInfo({ customer, formatMoney }: Props) {
  const hasPortalLink = !!customer.portalToken;
  const linkExpired = customer.portalToken?.expiresAt
    ? new Date(customer.portalToken.expiresAt).getTime() < Date.now()
    : false;
  const hasPortalInfo = !!(
    customer.portalToken?.lastPaymentAt ||
    (hasPortalLink && customer.portalToken?.expiresAt) ||
    customer.lastReminderAt
  );

  if (!hasPortalInfo) return null;

  return (
    <View style={modalExperience.detailFlatSection}>
      <Text style={modalExperience.detailBlockTitle}>Link de pago y recordatorios</Text>
      {customer.portalToken?.lastPaymentAt ? (
        <View style={modalExperience.detailKvRow}>
          <Text style={modalExperience.detailMetaLabel}>Último pago</Text>
          <Text style={modalExperience.detailKvValueStrong}>
            {formatLocalDate(customer.portalToken.lastPaymentAt)}
            {customer.portalToken.lastPaymentAmount != null
              ? ` · ${formatMoney(customer.portalToken.lastPaymentAmount)}`
              : ''}
          </Text>
        </View>
      ) : null}
      {hasPortalLink && customer.portalToken?.expiresAt ? (
        <View style={modalExperience.detailKvRow}>
          <Text style={modalExperience.detailMetaLabel}>El link vence</Text>
          <Text
            style={[
              modalExperience.detailKvValueStrong,
              linkExpired && modalExperience.detailMetaValueDanger,
            ]}
          >
            {formatLocalDate(customer.portalToken.expiresAt)}
            {linkExpired ? ' · Vencido' : ''}
          </Text>
        </View>
      ) : null}
      {customer.lastReminderAt ? (
        <View style={modalExperience.detailKvRow}>
          <Text style={modalExperience.detailMetaLabel}>Último recordatorio</Text>
          <Text style={modalExperience.detailKvValueStrong}>
            {formatLocalDate(customer.lastReminderAt)}
          </Text>
        </View>
      ) : null}
    </View>
  );
}
